import * as Sentry from '@sentry/vue';

export default defineNuxtPlugin((nuxtApp) => {
  const { sentryDsn, appVersion } = useRuntimeConfig().public;
  if (!sentryDsn) return;

  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: sentryDsn,
    release: `eve-log-web@${appVersion}`,
    environment: import.meta.dev ? 'development' : 'production',
    tracesSampleRate: 0.1,
  });
});
